import { getCurrentTokenWithoutRedirect } from "@adsk/acs-sc-web-platform-api";
import {
  addXRequestedByHeaderTransformer,
  buildRequestHeadersTransformer,
} from "./RawApiClient";
const FUNCTION_NAME = "serviceOriginRequestTransformer";
/**
 * Request transformer which prepends a `serviceUrl` to a request and adds the
 * ACC Bearer token
 *
 * @param serviceName Name of the service (used only for logging)
 * @param serviceUrl URL prefix of the service (must include complete origin,
 *   may include a path)
 */
export default function serviceOriginRequestTransformer(
  serviceName,
  serviceUrl
) {
  if (typeof window === "undefined") {
    const message = `\`${FUNCTION_NAME}("${serviceName}")\` is only supported for browser clients.`;
    return r => {
      console.error(message); // tslint:disable-line:no-console
      return r;
    };
  }
  const sUrl = new URL(serviceUrl);
  return async urlAndInit => {
    const serviceUrlRequestTransformer = ({ url, init }) => {
      const u = new URL(url, "http://example.com");
      const uPath = u.pathname.replace(/\/$/, "");
      return {
        url: `${sUrl.origin}${sUrl.pathname}${uPath}${u.search}`,
        init,
      };
    };
    const headers = {};
    try {
      const { accessToken } = await getCurrentTokenWithoutRedirect();
      headers.authorization = "Bearer " + accessToken;
    } catch (e) {}
    const authorizationHeaderTransformer = buildRequestHeadersTransformer(
      headers
    );
    return authorizationHeaderTransformer(
      addXRequestedByHeaderTransformer(
        serviceUrlRequestTransformer(authorizationHeaderTransformer(urlAndInit))
      )
    );
  };
}
